import { fromJS } from 'immutable';
import * as actions from '@modules/conferencing/actions/global';
import { SUCCESS, START, ERROR } from '@modules/conferencing/actions/global';
import { fetchingState } from '@constants';
import * as _ from 'lodash';

const initialStats = {
  preference: {},
  meetingTypes: { data: [], state: null},
  waitingRoomTypes: { data: [], state: null},
  informalRoutingOptions: {data: [], state: null},
  insertionRules: { data: [], state: null},
  waitingRoomConfig: { data: [], state: null },
  waitingRoomRecords: { data: [], state: null },
  waitingRoomAllRecords: { data: [], state: null },
  similarRooms: { data: [], state: null },
  waitingRoomConfigOptions: { data: {}, state: null },
  selectedWaitingRoom: null,
};

export default (state = fromJS(initialStats), action) => {
  let newState;
  switch (action.type) {
    case actions.PREFERENCE_FETCH[START]:
      return state.setIn(['preference', 'state'], fetchingState.FETCHING);
    case actions.PREFERENCE_FETCH[SUCCESS]:
      newState = state.setIn(['preference', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['preference', 'data'],
        fromJS(
          action.data.results.length > 0
            ? action.data.results[0].preference
            : {},
        ),
      );
    case actions.PREFERENCE_FETCH[ERROR]:
      return state.setIn(['preference', 'state'], fetchingState.ERROR);

    case actions.PREFERENCE_PERSIST[SUCCESS]:
      newState = state.setIn(['preference', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['preference', 'data'],
        fromJS(
          action.data.results.length > 0
            ? action.data.results[0].preference
            : {},
        ),
      );

    case actions.FETCH_WAITING_ROOM_CONFIG_OPTIONS[START]: {
        return state
          .setIn(['meetingTypes', 'state'], fetchingState.FETCHING)
          .setIn(['waitingRoomTypes', 'state'], fetchingState.FETCHING)
          .setIn(['insertionRules', 'state'], fetchingState.FETCHING)
          .setIn(['informalRoutingOptions', 'state'], fetchingState.FETCHING)
          .setIn(['waitingRoomConfigOptions', 'state'], fetchingState.FETCHING);
      }
      case actions.FETCH_WAITING_ROOM_CONFIG_OPTIONS[SUCCESS]: {
        return state
          .setIn(['meetingTypes', 'state'], fetchingState.LOADED)
          .setIn(['waitingRoomTypes', 'state'], fetchingState.LOADED)
          .setIn(['insertionRules', 'state'], fetchingState.LOADED)
          .setIn(['informalRoutingOptions', 'state'], fetchingState.LOADED)
          .setIn(['waitingRoomConfigOptions', 'state'], fetchingState.LOADED)
          .setIn(['meetingTypes', 'data'], fromJS(_.get(action, 'data.results.meetingTypes', [])))
          .setIn(['waitingRoomTypes', 'data'], fromJS(_.get(action, 'data.results.roomTypes', [])))
          .setIn(['insertionRules', 'data'], fromJS(_.get(action, 'data.results.insertionRules', [])))
          .setIn(['informalRoutingOptions', 'data'], fromJS(_.get(action, 'data.results.informalRoutingOptions', [])))
          .setIn(['waitingRoomConfigOptions', 'data'], fromJS(_.get(action, 'data.results', {})));
      }
      case actions.FETCH_WAITING_ROOM_CONFIG_OPTIONS[ERROR]: {
        return state
          .setIn(['meetingTypes', 'state'], fetchingState.ERROR)
          .setIn(['waitingRoomTypes', 'state'], fetchingState.ERROR)
          .setIn(['insertionRules', 'state'], fetchingState.ERROR)
          .setIn(['informalRoutingOptions', 'state'], fetchingState.ERROR)
          .setIn(['waitingRoomConfigOptions', 'state'], fetchingState.ERROR);
      }

    case actions.FETCH_WAITING_ROOM_CONFIG[START]: {
      return state
        .setIn(['waitingRoomConfig', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_WAITING_ROOM_CONFIG[SUCCESS]: {
      return state
        .setIn(['waitingRoomConfig', 'state'], fetchingState.LOADED)
        .setIn(['waitingRoomConfig', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.FETCH_WAITING_ROOM_CONFIG[ERROR]: {
      return state
        .setIn(['waitingRoomConfig', 'state'], fetchingState.ERROR);
    }

    case actions.CLEAR_WAITING_ROOM_RECORDS: {
      return state
        .setIn(['waitingRoomRecords', 'data'], fromJS([]));
    }
    case actions.CLEAR_ALL_WAITING_ROOM_RECORDS: {
      return state
        .setIn(['waitingRoomAllRecords', 'data'], fromJS([]));
    }

    case actions.FETCH_WAITING_ROOM_RECORDS[START]: {
      return state
        .setIn(['waitingRoomRecords', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_WAITING_ROOM_RECORDS[SUCCESS]: {
      return state
        .setIn(['waitingRoomRecords', 'state'], fetchingState.LOADED)
        .setIn(['waitingRoomRecords', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.FETCH_WAITING_ROOM_RECORDS[ERROR]: {
      return state
        .setIn(['waitingRoomRecords', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_SORT_WAITING_ROOM_RECORDS[START]: {
      return state
        .setIn(['waitingRoomRecords', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_SORT_WAITING_ROOM_RECORDS[SUCCESS]: {
      return state
        .setIn(['waitingRoomRecords', 'state'], fetchingState.LOADED)
        .setIn(['waitingRoomRecords', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.FETCH_SORT_WAITING_ROOM_RECORDS[ERROR]: {
      return state
        .setIn(['waitingRoomRecords', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_WAITING_ROOM_ALL_RECORDS_BY_TYPE[START]:
    case actions.FETCH_WAITING_ROOM_ALL_RECORDS[START]: {
      return state
        .setIn(['waitingRoomAllRecords', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_WAITING_ROOM_ALL_RECORDS_BY_TYPE[SUCCESS]:
    case actions.FETCH_WAITING_ROOM_ALL_RECORDS[SUCCESS]: {
      return state
        .setIn(['waitingRoomAllRecords', 'state'], fetchingState.LOADED)
        .setIn(['waitingRoomAllRecords', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.FETCH_WAITING_ROOM_ALL_RECORDS_BY_TYPE[ERROR]:
    case actions.FETCH_WAITING_ROOM_ALL_RECORDS[ERROR]: {
      return state
        .setIn(['waitingRoomAllRecords', 'state'], fetchingState.ERROR);
    }

    case actions.MOVE_WAITING_ROOM_RECORD[START]: {
      return state
        .setIn(['waitingRoomRecords', 'state'], fetchingState.FETCHING);
    }
    case actions.MOVE_WAITING_ROOM_RECORD[SUCCESS]: {
      return state
        .setIn(['waitingRoomRecords', 'state'], fetchingState.LOADED)
        .setIn(['waitingRoomRecords', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.MOVE_WAITING_ROOM_RECORD[ERROR]: {
      return state
        .setIn(['waitingRoomRecords', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_SIMILAR_ROOMS[START]: {
      return state
        .setIn(['similarRooms', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_SIMILAR_ROOMS[SUCCESS]: {
      return state
        .setIn(['similarRooms', 'state'], fetchingState.LOADED)
        .setIn(['similarRooms', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.FETCH_SIMILAR_ROOMS[ERROR]: {
      return state
        .setIn(['similarRooms', 'state'], fetchingState.ERROR);
    }

    case actions.SET_SELECTED_WAITING_ROOM: {
      return state
        .setIn(['selectedWaitingRoom'], fromJS(_.get(action, 'payload', {})));
    }

    default:
      return state;
  }
};
